<div style="display: flex; flex-direction: column; flex: 1 1 100%" [class]="bodyClasses">
  <div
    style="display: flex; flex-direction: row; align-items: stretch; flex: 0 0 auto"
    *ngIf="hasAlert"
    class="bfx-app-alert-header"
  >
    <i [class]="alertIconClass" ngClass="ds-cont-typography-icon-md"></i>
    <span [class]="titleClasses">{{alertText}}</span>
  </div>
  <ng-content></ng-content>
</div>
